import { Col, Input, Row, Form, Button, message } from "antd"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { AuthContext } from "../../../../contexts/auth/AuthContext"
import { UPDATE_USER_PASSWORD } from "../../../../rest-api/mutations/user"
import { useMutation } from "@tanstack/react-query"

export default function PasswordUpdate() {
  const { t } = useTranslation()
  const { authState } = useContext(AuthContext)
  const {
    mutate: updatePassword,
    isLoading: loading,
    error,
  } = useMutation(UPDATE_USER_PASSWORD, {
    onSuccess: (data) => {
      //  if (data.data?.updateUsers?.id) {
      message.success(t("success"))
      //  } else {
      //    message.error(t("error"))
      //  }
    },
    onError: (err) => {
      message.error(t(String(err)))
    },
  })

  function handleFinish(values: any) {
    // TODO remove role
    updatePassword({
      ...authState.user,
      password: values.password,
      confirmPassword: values.confirmPassword,
    })
  }

  return (
    <Form onFinish={handleFinish} layout="vertical" requiredMark>
      <Row gutter={15}>
        <Col xs={24} sm={12}>
          <Form.Item
            name="password"
            label={t("password")}
            rules={[{ required: true }]}
          >
            <Input.Password size="large" placeholder={t("password")} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="confirmPassword"
            label={t("confirmPassword")}
            rules={[{ required: true }]}
          >
            <Input.Password size="large" placeholder={t("confirmPassword")} />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Button
            loading={loading}
            danger={!!error}
            block
            type="primary"
            htmlType="submit"
          >
            {t("save")}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
